import { useNavigate } from "react-router-dom";
import React from "react";
import {
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Flex,
  Button,
  useDisclosure,
  Link,
  IconButton,
  Text,
} from "@chakra-ui/react";
import { HamburgerIcon, ChevronLeftIcon } from "@chakra-ui/icons";
import { HomeIcon, AboutIcon, WorkIcon } from "./navIcons";

export default function NavbarMobile() {
  const urlList = window.location.href.split("/");
  const selectedWindow = urlList[urlList.length - 1];
  const { isOpen, onOpen, onClose } = useDisclosure();
  const navigate = useNavigate();
  const handleGetInTouch = () => {
    navigate("/contact");
  };

  return (
    <Flex>
      <Flex
        justifyContent={"space-between"}
        width={"100%"}
        marginX={3}
        marginTop={3}
      >
        <IconButton
          backgroundColor={"transparent"}
          color={"white"}
          onClick={onOpen}
          _hover={{ backgroundColor: "#34A9A7" }}
          aria-label="Navigation Bar"
          icon={<HamburgerIcon />}
        />
        <Button
          backgroundColor={"#34A9A7"}
          color={"gray.100"}
          background={"transparent"}
          _hover={{ background: "", transform: "scale(1.05)" }}
          animation={"all 0.3s ease-in-out"}
          onClick={handleGetInTouch}
          size={"sm"}
        >
          Get in touch
        </Button>
      </Flex>

      <Drawer isOpen={isOpen} placement="left" onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>
            <Button
              p={0}
              size={"sm"}
              leftIcon={<ChevronLeftIcon />}
              variant="solid"
              backgroundColor={"transparent"}
              _hover={{ backgroundColor: "" }}
              onClick={onClose}
            >
              Back
            </Button>
          </DrawerHeader>

          <DrawerBody p={0} ml={5}>
            <Flex direction={"column"} gap={3}>
              <Link href="/">
                <Flex
                  gap={3}
                  width={"100%"}
                  backgroundColor={
                    selectedWindow === "" ? "#34A9A7" : "transparent"
                  }
                  color={selectedWindow === "" ? "white" : "black"}
                  padding={3}
                  alignItems={"center"}
                >
                  <HomeIcon
                    style={{ width: 20, height: 20 }}
                    fillColor={selectedWindow === "" ? "white" : ""}
                  />
                  <Text>Home</Text>
                </Flex>
              </Link>

              <Link href="/about">
                <Flex
                  gap={3}
                  width={"100%"}
                  backgroundColor={
                    selectedWindow === "about" ? "#34A9A7" : "transparent"
                  }
                  color={selectedWindow === "about" ? "white" : "black"}
                  padding={3}
                  alignItems={"center"}
                >
                  <AboutIcon
                    fillColor={selectedWindow === "about" ? "white" : ""}
                    style={{
                      width: 20,
                      height: 20,
                    }}
                  />
                  <Text>About</Text>
                </Flex>
              </Link>

              <Link href="/work">
                <Flex
                  gap={3}
                  width={"100%"}
                  backgroundColor={
                    selectedWindow === "work" ? "#34A9A7" : "transparent"
                  }
                  color={selectedWindow === "work" ? "white" : "black"}
                  padding={3}
                  alignItems={"center"}
                >
                  <WorkIcon
                    fillColor={selectedWindow === "work" ? "white" : ""}
                    style={{
                      width: 20,
                      height: 20,
                    }}
                  />
                  <Text>Work</Text>
                </Flex>
              </Link>
            </Flex>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Flex>
  );
}
